"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOON_PHASE_LAST_QUARTER = exports.MOON_PHASE_FULL_MOON = exports.MOON_PHASE_FIRST_QUARTER = exports.MOON_PHASE_NEW_MOON = void 0;
exports.MOON_PHASE_NEW_MOON = 0;
exports.MOON_PHASE_FIRST_QUARTER = 0.25;
exports.MOON_PHASE_FULL_MOON = 0.5;
exports.MOON_PHASE_LAST_QUARTER = 0.75;
